import React, { Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import { clearCharacter } from '../../actions/character';

import logoImg from '../../img/logo_K.png';
import galToK from '../../img/gal-to-k.gif';

const Navbar = ({ auth: { isAuthenticated, loading }, logout, clearCharacter }) => {

    const logoutUser = () => {
        logout();
        clearCharacter();
    }

    const authLinks = (
        <ul>
            <li>
                <Link to="/about">About</Link>
                <Link to="/wiki">Wiki</Link>
                <Link to="/dashboard">Dashboard</Link>
                <Link to="/" onClick={logoutUser} href="#!">Logout</Link>
            </li>
        </ul>
    );

    const guestLinks = (
            <ul>
                <li>
                    <Link to="/about">About</Link>
                    <Link to="/register">Register</Link>
                    <Link to="/login">Login</Link>
                </li>
            </ul>
    );

    return (
        <nav className="navbar bg-dark">
            <Link to="/">
                <div className='logoContainer'>
                    <img src={galToK} className="logo" />
                    <h1>ALEIDO</h1>
                </div>
            </Link>
            
            {!loading && (
                <Fragment>{ isAuthenticated ? authLinks : guestLinks }</Fragment>
            )}
        </nav>
    )
}

Navbar.propTypes = {
    logout: PropTypes.func.isRequired,
    clearCharacter: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, {logout, clearCharacter})(Navbar);
